import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { navigateToFirstPage } from "../../utils/Utilities";
import { useNavigate } from "react-router-dom";
const JoinNow = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box px={8} py={8}>
      <Box sx={{ textAlign: "center" }}>
        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
          <Typography mt={5} fontSize={"1.25rem"} width={"70%"} className="Join-now">
            {t("join-now-h1")}
          </Typography>
        </Box>

        <Button
          onClick={() => {
            navigateToFirstPage(navigate);
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}
          sx={{
            margin: "70px auto 20px auto",
            background: "#444660",
            textTransform: "initial",
            color: "white",
            padding: "15px 55px",
            borderRadius: "7px",
            fontSize: "1.35rem",
            fontWeight: "700",
            "&:hover": { background: "#00000020", color: "#444660" },
          }}
          className="join-now-button"
        >
          {t("join-now-btn")}
        </Button>
      </Box>
    </Box>
  );
};

export default JoinNow;
